import { parseCalendarDate } from './utils';

/**
 * Given a dateStr (YYYY-MM-DD), return the set of dateStr values
 * for the ISO week (Mon-Sun) containing that date.
 * We use Sunday-start weeks to match the calendar views.
 */
export function getWeekDates(dateStr: string): Set<string> {
  const d = parseCalendarDate(dateStr);
  const day = d.getUTCDay(); // 0=Sun, 6=Sat
  const result = new Set<string>();

  // Go to Sunday of this week
  const sunday = new Date(d);
  sunday.setUTCDate(sunday.getUTCDate() - day);

  for (let i = 0; i < 7; i++) {
    const cur = new Date(sunday);
    cur.setUTCDate(cur.getUTCDate() + i);
    const str = `${cur.getUTCFullYear()}-${String(cur.getUTCMonth() + 1).padStart(2, '0')}-${String(cur.getUTCDate()).padStart(2, '0')}`;
    result.add(str);
  }

  return result;
}
